export function pmt(rate, nper, pv, fv = 0, end = true) {
  const when = end ? 0 : 1;
  const temp = Math.pow(1 + rate, nper);
  const maskedRate = rate === 0 ? 1 : rate;
  const fact =
    rate === 0 ? nper : ((1 + maskedRate * when) * (temp - 1)) / maskedRate;
  return (fv + pv * temp) / fact;
}
